import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background px-4 py-10 sm:px-6">
      <div className="mx-auto w-full max-w-3xl rounded-2xl border border-border/70 bg-card p-6 shadow-sm sm:p-8">
        <h1 className="text-2xl font-semibold tracking-tight">
          Política de Privacidad - Clara
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Esta página describe cómo tratamos datos de cuenta y autenticación en
          Clara.
        </p>

        <div className="mt-6 space-y-4 text-sm leading-6 text-foreground/90">
          <p>
            Usamos tu información de autenticación para permitir el acceso a tu
            cuenta y mantener la seguridad de la sesión.
          </p>
          <p>
            Proveedores de identidad como Google se usan únicamente para validar
            identidad y no para publicar contenido en tu nombre.
          </p>
          <p>
            Si necesitás solicitar eliminación o actualización de datos,
            escribinos a{" "}
            <a
              href="mailto:privacidad@daleclara.com"
              className="underline underline-offset-2"
            >
              privacidad@daleclara.com
            </a>
            .
          </p>
        </div>

        <div className="mt-8">
          <Link to="/login" className="text-sm underline underline-offset-2">
            Volver al login
          </Link>
        </div>
      </div>
    </div>
  );
}
